import React, { Component } from "react";
import Icon from "../Common/Icon";
import connect from "react-redux/es/connect/connect";
import PropTypes from "prop-types";

class List extends Component {
  static propTypes = {
    config: PropTypes.object,
  };

  render() {
    const { productsInfo = {}, filters = {}, config = {} } = this.props;

    const filterList = JSON.parse(config.list.filterList);
    if (!productsInfo.products) return null;

    const productsByTypes = {};
    productsInfo.products
      .filter((product) => {
        return Object.keys(filters).every((filterName) => {
          if (filters[filterName].length) {
            return filters[filterName].some((filterValue) => {
              return !!product[filterName].find(
                (value) => value === filterValue
              );
            });
          }
          return true;
        });
      })
      .forEach((product) => {
        product.types.forEach((type) => {
          if (!productsByTypes[type]) {
            productsByTypes[type] = [];
          }
          productsByTypes[type].push(product);
        });
      });

    const filterd = Object.entries(productsByTypes).sort(function ([a], [b]) {
      return filterList.indexOf(a) - filterList.indexOf(b);
    });
    const productsFilteredByType = Object.fromEntries(filterd);
    function removeItemEticketForm() {
      sessionStorage.setItem("eticket-form", "");
      return true;
    }

    return (
      <div className="container container--accent1-tint5 container--clearfix">
        <div className="container container--center container--margin">
          {Object.keys(productsFilteredByType).map((type) => {
            return (
              <React.Fragment key={type}>
                <h2>{type}</h2>
                <div className="container--margin">
                  <div className="grid">
                    {productsFilteredByType[type].map((product) => {
                      return (
                        <div className="grid__column" key={product.detailsLink}>
                          <div className="container--white popular-products__border">
                            <div class="block__container--top-band"></div>
                            <div className="block__container--product-title">
                              <h4 className="block__container--product-title-h4">
                                {product.name}
                              </h4>
                            </div>
                            <div className="block__content teaser-product__info">
                              <div className="teaser-product__specs">
                                {product.specifications.map((spec) => {
                                  return (
                                    <div
                                      className="teaser-product__spec"
                                      key={JSON.stringify(spec)}
                                    >
                                      <div className="teaser-product__spec-icon">
                                        <Icon iconName={spec.icon} />
                                      </div>
                                      <div className="teaser-product__spec-description">
                                        {spec.description}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                              <div>
                                <span className="popular-products__price-from">
                                  {config.priceFrom}{" "}
                                </span>
                                <span className="popular-products__price">
                                  € {product.price}
                                </span>{" "}
                                <span className="popular-products__price-from">
                                  {product.pricePeriod}
                                </span>
                              </div>
                            </div>
                            <div>
                              <hr class="popular-products__hr" />
                            </div>
                            <div className="popular-products__buttons-container">
                              <div className="popular-products__buttons">
                                <a
                                  href={product.detailsLink}
                                  className="link link--animation-on-hover"
                                >
                                  {productsInfo.productDetailsLinkText}
                                  <Icon
                                    iconName="arrow-right"
                                    className="link__icon link__icon--right"
                                  />
                                </a>
                                {product.showOrderText ? (
                                  <a
                                    href={product.purchaseLink}
                                    className="btn btn--lightgrey2 teaser-product__btn"
                                    onclick={removeItemEticketForm()}
                                  >
                                    <span className="desktop-large-hide">
                                      <Icon
                                        iconName="mand"
                                        className="link__icon"
                                      />
                                    </span>
                                    <span className="desktop-large-only">
                                      {productsInfo.productPurchaseLinkText}
                                      <Icon
                                        iconName="arrow-right"
                                        className="link__icon link__icon--right"
                                      />
                                    </span>
                                  </a>
                                ) : (
                                  <p className="title">{product.orderText}</p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    productsInfo: state.shop.productsInfo,
    filters: state.shop.filters,
  }),
  {}
)(List);



// WEBPACK FOOTER //
// ./src/components/ShopOverview/List.js